/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum WorkDayType {
  INTERVAL = 'interval',
  FIXED = 'fixed',
  NOT_WORKING = 'not_working',
}
